// Modal.tsx

import React, {ReactNode} from "react";
import styles from "./BaseModal.module.scss";

interface ModalType {
	id?: string;
	children?: ReactNode;
	isOpen: boolean;
	pinToTop?: boolean;
	overlayOnly?: boolean;
	toggle: () => void;
}

/**
 * Base for modal components.  In general, you should use ./GlobalModal instead.
 */
export default function BaseModal(props: ModalType) {
	return (
		<>
			{props.isOpen && (
				<div
					id={props.id}
					className={[
						styles.modalOverlay,
						props.pinToTop ? styles.absoluteOverlay : "",
						props.overlayOnly ? styles.softOverlay : "",
					].join(" ")}
					onClick={props.toggle}
					aria-modal="true"
				>
					<div
						onClick={(e) => e.stopPropagation()}
						className={[
							styles.modalBox,
							props.pinToTop ? styles.pinToTop : "",
							props.overlayOnly ? styles.noModal : "",
						].join(" ")}
						role="dialog"
					>
						{props.children}
					</div>
				</div>
			)}
		</>
	);
}
